import React from 'react';
import '../../styles/publish/Publish.css';
import LocationCityIcon from '@material-ui/icons/LocationCity';


function Publish() {
  const handleSend = (e) => {
    e.preventDefault();
    alert('Solicitud enviada ¡Muchas gracias por elegirnos!');
  };
  return (
    <div className="publish">
      <div className="publish-container">
        <h2 className="publish-container__title">Publica tu alojamiento</h2>
        <form className="publish-form">
          <label>Título:</label>
          <input
            type="text"
            name="title"
            className="form-control form-control--title"
            autoFocus
            spellCheck="false"
            autoComplete="off"
          />
          <label>Dirección:</label>
          <input
            type="text"
            name="address"
            className="form-control form-control--address"
            spellCheck="false"
          />
          <label>Nombre del anfitrión/a:</label>
          <input
            type="text"
            name="name"
            className="form-control form-control--host"
            spellCheck="false"
          />
          <label>Correo electrónico:</label>
          <input
            type="email"
            name="email"
            className="form-control form-control--email"
            spellCheck="false"
          />
          <label>Descripción:</label>
          <textarea name="description"></textarea>
          <label>Imagen:</label>
          <input
            type="file"
            name="image"
            className="form-control form-control--file"
            spellCheck="false"
          />
          <button className="publish__send" onClick={handleSend}>
            Enviar para revisión
          </button>
        </form>
      </div>
    </div>
  );
}

export default Publish;
